import type { AutoString } from 'types/utils';
import { isObject } from './assertions';

export type TAppError = {
  code: AutoString<'unknown' | 'client_error' | 'unauthorized'>;
  message: string;
  url?: string;
  data?: Record<string, unknown>;
};

export function isAppError(error: unknown): error is TAppError {
  if (!isObject(error)) return false;
  if ('code' in error && typeof error.code === 'string' && 'message' in error && typeof error.message === 'string') {
    return true;
  }
  return false;
}

export function getAppError(data: unknown, defaultError?: TAppError): TAppError {
  const defaultToUse = defaultError ?? { code: 'unknown', message: 'Unknown error' };
  if (isAppError(data)) {
    return data;
  }

  if (data instanceof Error) {
    return { ...defaultToUse, message: data.message };
  }
  if (typeof data === 'string') {
    return { ...defaultToUse, message: data };
  }
  return defaultToUse;
}

/** @deprecated */
export function logError(message: string, error?: unknown) {
  const date = new Date();
  console.error(`${date.toLocaleDateString()} ${date.toLocaleTimeString()}${message ? `: ${message}` : ''}`, JSON.stringify(error ?? ''));
}
